<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Income sections')"
          :description="$t('From Here Control Over Income Sections')"
        />
        <indexTable
          :searchText="$t('Search For a section')"
          :emptyTableText="$t('There are no sections')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('incomes_add')"
          :cloumns="[
            {
              column: 'name',
              title: $t('Section name'),
              type: 'text',
              sort: true
            },
            {
              column: 'income_section_id',
              title: $t('Father section'),
              type: 'link',
              to: 'incomeSection',
              sort: true,
              link: false
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: $checkRole('incomes_edit') },
                {
                  name: 'delete',
                  role: $checkRole('incomes_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/incomeSections'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
